import { ResponseType, VirtualTourType } from '@/types';
import { axios } from '../baseAxios';

const REACT_APP_GRAPHQL_API = process.env.REACT_APP_GRAPHQL_API || `https://ci-api.clik.vn/graphql`;

export const searchVT360GraphQL = async (
  textQuery?: string,
  excludeCodes?: string[]
): Promise<ResponseType<VirtualTourType[]>> => {
  const graphqlQuery = `
    query Query($textQuery: String, $excludeCodes: [String!], $size: Float, $page: Float) {
      searchTours(textQuery: $textQuery, excludeCodes: $excludeCodes, size: $size, page: $page) {
        content {
          code
          name
          products {
            code
            name
          }
        }
        number
        size
        totalElements
        last
      }
    }
`;

  const res = await axios({
    url: REACT_APP_GRAPHQL_API,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: JSON.stringify({
      query: graphqlQuery,
      variables: { textQuery, excludeCodes, size: 10, page: 0 },
    }),
  });

  return {
    data: res?.data?.data?.searchTours,
  };
};

export const searchProducts = async ({
  textQuery,
  excludeCodes = [],
  tourCodes = [],
  size = 20,
  page = 0,
  emailCreator,
}: {
  textQuery?: string;
  excludeCodes?: string[];
  tourCodes?: string[];
  emailCreator?: string;
  size?: number;
  page?: number;
}): Promise<ResponseType<VirtualTourType[]>> => {
  const graphqlQuery = `
    query Query($textQuery: String, $excludeCodes: [String!], $size: Float, $page: Float, $tourCodes: [String!], $emailCreator: String) {
      searchProducts(textQuery: $textQuery, excludeCodes: $excludeCodes, size: $size, page: $page, tourCodes: $tourCodes, emailCreator: $emailCreator) {
         content {
          code
          name
          tourCode
        }
        number
        size
        totalElements
        last
      }
    }
`;

  const res = await axios({
    url: REACT_APP_GRAPHQL_API,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    data: JSON.stringify({
      query: graphqlQuery,
      variables: { textQuery, excludeCodes, tourCodes, size, page, emailCreator },
    }),
  });

  return {
    data: res?.data?.data?.searchProducts,
  };
};
